import { AttrTypeName } from "src/types/AttrType";
import { zUid } from "src/types/zUid";
import { z } from "zod";

const zLinksMap = z.record(z.string(), z.string().array());
const zRolesMap = z.record(z.string(), zUid.array());

const zAttrLabelMetaWithLinks = z.object({
  type: z.enum([
    AttrTypeName.object,
    AttrTypeName.dictMulti,
    AttrTypeName.dictSingle,
    AttrTypeName.childEntities,
  ]),
  links: zLinksMap,
});

const zAttrLabelMetaUserList = z.object({
  type: z.literal(AttrTypeName.usersList),
  links: zLinksMap,
  roles: zRolesMap,
});

export const zCurrencySignLocationCode = z.enum(["signAfter", "signBefore"]);
export type ZCurrencySignLocationCode = z.infer<
  typeof zCurrencySignLocationCode
>;

const zAttrLabelMetaFinancial = z.object({
  type: z.literal(AttrTypeName.financial),
  sign: z.string(),
  signPosition: zCurrencySignLocationCode,
});

export type ZAttrLabelMetaFinancial = z.infer<typeof zAttrLabelMetaFinancial>;

export const zAttrLabelMeta = z.discriminatedUnion("type", [
  zAttrLabelMetaWithLinks,
  zAttrLabelMetaFinancial,
  zAttrLabelMetaUserList,
]);

export type ZAttrLabelMeta = z.infer<typeof zAttrLabelMeta>;
